<style>
.root {
  display: flex;
  height: 2rem;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: inset 0 1px 4px 1px rgba(0,0,0,0.2);
}

.bar {
  position: relative;
}

.bar:after {
  content: "";
  display: block;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 0;
  background-repeat: no-repeat;
  background-image: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.3),
    rgba(0, 0, 0, 0.35) 65%
  );
}
.pending.bar:after {
  animation: move 2s linear infinite;
  animation-duration: inherit;
}
.round {
  background-color: rgba(0,0,0,0.25);
  min-width: 10px;
  flex: 1;
}
.break {
  background-color: rgba(0,0,0,0.1);
  flex: 1;
}
@keyframes move {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}
.done {
  background-color: rgba(0,0,0,0.48);
}
</style>

<script>
  export let timeOn = 0;
  export let timeOff = 0;
  export let completed = [];
  export let steps = [];
  export let isRunning = false;
  $: ratio = timeOn / timeOff;
</script>

<div class="root">
  {#each steps as step, i}
    <div
      class="bar"
      class:round="{step.type === 'round'}"
      class:break="{step.type === 'break'}"
      class:pending="{isRunning && i === completed.length}"
      class:done="{completed[i] !== undefined}"
      style="flex: {step.type === 'round' && ratio}; animation-duration: {step.duration}s;">
    </div>
  {/each}
</div>
